// extracted by mini-css-extract-plugin
var _1 = "B8CQfR7H";
export { _1 as "newInternetResourceContainer" }
